import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TransactionActions from '../../../../redux/Transaction/actions';

const {
    setShowShipping,
} = TransactionActions;

export function useShowShipping({ form, specs }) {
    const dispatch = useDispatch();

    // Redux
    const transaction = useSelector(state => state.Transaction.transaction);
    const company = useSelector(state => state.Company.company);

    const onShowShippingChange = useCallback(value => {
        dispatch(
            setShowShipping(value),
        );

        if (specs.companyAddresses) {
            // Find and set the default shipping address of company if checkbox is checked
            if (
                value &&
                !transaction.shipping_party &&
                !form.getFieldValue('shipping_party')
            )
                form.setFieldsValue({ shipping_party: company.shipping_address_text });

            // Find and set the original saved shipping address (if there is one) if checkbox is checked
            else if (
                value &&
                transaction.shipping_party &&
                !form.getFieldValue('shipping_party')
            )
                form.setFieldsValue({ shipping_party: transaction.shipping_party });

            // Remove shipping info when box is unticked
            if (!value)
                form.setFieldsValue({ shipping_party: '' });
        }
    }, [
        company.shipping_address_text,
        dispatch,
        form,
        specs.companyAddresses,
        transaction.shipping_party,
    ]);

    return {
        onShowShippingChange,
    };
}
